import React, { useState, useEffect } from "react";
import icon1 from "../../../assets/social-security-icons/spouse-ss-vs-fra.svg";
import timeIcon from "../../../assets/social-security-icons/time-remaing-retirement.svg";
import benefitIcon from "../../../assets/social-security-icons/benefit.svg";
import { ToolTipCreator } from "../../../helpers/ToolTipCreator";
import backIcon from "../../../assets/social-security-icons/backIcon.svg";
import { SocialSecurityFormFields } from "./SocialSecurityFormFields";
import { NumberCardSkeleton } from "../../Skeletons/DebtSkeleton";
import { SocialSecurityFormSkeleton } from "../../InsuranceNew/InsuraceDashboardComponents/SocialSecurityFormSkeleton";
import NewLoader from "../../../components/styled-components/loader/NewLoader";
import { Table } from "antd";
import { useHistory } from "react-router-dom";
import "../styles/socialSecurity.css";
import { SocialSecurityHardCodeFields } from "./SocialSecurityHardCodeFields";
import { formatCurrencyAmount } from "../../../helpers/formatAmount";
import { MODULE_API } from "../../../apis";
import {
  calculateSpousalRow,
  calculateSpouseRemainingRetirementAge,
  generateSpousalTable,
  getFRAFromBirthYear,
} from "../../../helpers/SpousalFRACalculation";
import { calculateSocialSecurityResults } from "../../../helpers/socialSecurityCalculations";
import CombinedSocialSecurityTable from "./CombinedSocialSecurityTable";

export const SocialSecurityEarlyvsFRA = () => {
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState(null);
  const [results, setResults] = useState(null);
  const [userEntryResults, setUserEntryResults] = useState(null);
  const [socialFieldsData, setSocialFieldsData] = useState(null);
  const [tableData, setTableData] = useState(null);
  const [loadingAttributes, setLoadingAttributes] = useState(false);
  const [attributes, setAttributes] = useState(null);
  const module = "Spouse Social Security vs Retirement Age";
  const moduleDataToFetch = "Social Security Calculator";

  const handleChange = (name, value) => {
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const formFields = [
    {
      label: "Spouse Date of Birth",
      type: "date",
      name: "spouseYearOfBirth",
    },
    {
      label: "Enter years",
      type: "number",
      name: "years",
    },
    {
      label: "Enter months",
      type: "number",
      name: "months",
    },
  ];
  const resultArray = [
    {
      id: 1,
      name: "Time until Full Retirement Age",
      icon: timeIcon,
      value:
        formData &&
        formData["Enter Years"] &&
        (formData["Spouse Date of Birth"] ||
          socialFieldsData && socialFieldsData["Spouse Birthdate"])
          ? calculateSpouseRemainingRetirementAge(
              formData["Spouse Date of Birth"] ||
                socialFieldsData && socialFieldsData["Spouse Birthdate"],
              formData["Enter Years"],
              formData["Enter Months"] || 0
            )
          : "N/A",
    },
    {
      id: 2,
      name: "Spousal benefit at FRA:",
      icon: benefitIcon,
      value:
        socialFieldsData &&
        socialFieldsData["Spouse Monthly Benefit at FRA ($)"]
          ? formatCurrencyAmount(
              socialFieldsData["Spouse Monthly Benefit at FRA ($)"]
            )
          : "$0.00",
    },
  ];
  const columns = [
    {
      title: "Age to take Social Secuity",
      dataIndex: "Early start age",
      key: "Early start age",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Months from Full Retirement Age",
      dataIndex: "months before FRA",
      key: "months before FRA",
      render: (record) => (record ? record : "0"),
    },
    {
      title: "% of FRA Benefit",
      dataIndex: "% of spouse FRA",
      key: "% of spouse FRA",
      render: (record) => (record ? `${record + "%"} ` : "N/A"),
    },
    {
      title: "Monthly Benefit",
      dataIndex: "Monthly Benefit",
      key: "Monthly Benefit",
      render: (record) => (record ? formatCurrencyAmount(record) : "N/A"),
    },
    {
      title: (
        <div className="social-security-table-heading">
          Break-even without TVM Interest
        </div>
      ),
      children: [
        {
          title: "Pre-FRA benefit",
          dataIndex: "Pre-FRA benefit",
          key: "Pre-FRA benefit",
          render: (record) => (record ? formatCurrencyAmount(record) : "N/A"),
        },
        {
          title: "Months to Break-even",
          dataIndex: "Months to Break-even",
          key: "Months to Break-even",
          render: (record) => (record ? record : "N/A"),
        },
        {
          title: "Age at Break-even",
          dataIndex: "Age at Break-even-formated",
          key: "Age at Break-even-formated",
          render: (record) => (record ? record : "N/A"),
        },
      ],
    },
    {
      title: (
        <div className="social-security-table-heading">
          Break-even with TVM and COLA
        </div>
      ),
      children: [
        {
          title: "Future value at FRA of pre-FRA benefit",
          dataIndex: "Future value at FRA of pre-FRA benefit",
          key: "Future value at FRA of pre-FRA benefit",
          render: (record) => (record ? formatCurrencyAmount(record) : "N/A"),
        },
        {
          title: "Months to Break-even",
          dataIndex: "Months to Break-even (TVM+COLA)",
          key: "Months to Break-even (TVM+COLA)",
          render: (record) => (record ? record : "N/A"),
        },
        {
          title: "Age at Break-even",
          dataIndex: "Age at Break-even-COLA-formated",
          key: "Age at Break-even-COLA-formated",
          render: (record) => (record ? record : "N/A"),
        },
      ],
    },
  ];

  const allResults = [
    {
      id: 1,
      name: "Months before FRA",
      value: userEntryResults ? userEntryResults["months before FRA"] : "N/A",
    },
    {
      id: 2,
      name: "% of FRA",
      value: userEntryResults
        ? userEntryResults["% of spouse FRA"] + "%"
        : "N/A",
    },
    {
      id: 3,
      name: "Monthly benefit ",
      value: userEntryResults
        ? formatCurrencyAmount(userEntryResults["Monthly Benefit"])
        : "N/A",
    },
    {
      id: 4,
      name: "Pre-FRA Benefit",
      value: userEntryResults
        ? formatCurrencyAmount(userEntryResults["Pre-FRA benefit"])
        : "N/A",
    },
    {
      id: 5,
      name: "Months to break-even",
      value: userEntryResults
        ? userEntryResults["Months to Break-even"]
        : "N/A",
    },
    {
      id: 6,
      name: "Age at break-even",
      value: userEntryResults
        ? userEntryResults["Age at Break-even"] &&
          parseFloat(userEntryResults["Age at Break-even"]).toFixed(2)
        : "N/A",
    },
    {
      id: 9,
      name: "Future Pre-FRA Benefit",
      value: userEntryResults
        ? formatCurrencyAmount(
            userEntryResults["Future value at FRA of pre-FRA benefit"]
          )
        : "N/A",
    },
    {
      id: 10,
      name: "Months to break-even",
      value: userEntryResults
        ? userEntryResults["Months to Break-even (TVM+COLA)"]
        : "N/A",
    },
    {
      id: 11,
      name: "Age at break-even",
      value: userEntryResults
        ? userEntryResults["Age at Break-even (TVM+COLA)"] &&
          parseFloat(userEntryResults["Age at Break-even (TVM+COLA)"]).toFixed(
            2
          )
        : "N/A",
    },
  ];

  const fetchData = async () => {
    try {
      setLoading(true);
      const res = await MODULE_API.fetchItems({
        moduleName: moduleDataToFetch,
        pageNum: 1,
        limit: 10,
        body: {},
      });
      // console.log("resssssss", res);
      if (res && res.records && res.records.length > 0) {
        setSocialFieldsData(res.records[0]);
        const socialData = res.records[0];
        const resultsAll = calculateSocialSecurityResults(res.records[0]);
        setResults(resultsAll);
        return socialData;
      }
    } catch (error) {
      console.error("Error fetching attributes", error);
    } finally {
      setLoading(false);
    }
  };
  const fetchModuleData = async (module, socialData) => {
    try {
      setLoading(true);
      const res = await MODULE_API.fetchItems({
        moduleName: module,
        pageNum: 1,
        limit: 10,
        body: {},
      });
      // console.log("resssssss", res);
      if (res && res.records && res.records.length > 0) {
        let data = { ...res.records[0] };
        if (
          !data["Spouse Date of Birth"] &&
          socialData &&
          socialData["Spouse Birthdate"]
        ) {
          data["Spouse Date of Birth"] = socialData["Spouse Birthdate"];
        }
        setFormData(data);
        let birthYear;
        if (data["Spouse Date of Birth"] || socialData["Spouse Birthdate"]) {
          const d = new Date(
            data["Spouse Date of Birth"] || socialData["Spouse Birthdate"]
          );
          if (!isNaN(d)) birthYear = d.getFullYear();
        }
        // fallback: if no DOB use a default or a value you already have
        const { fraYears, fraMonths } = getFRAFromBirthYear(birthYear || 1956);
        console.log("fraMonths", fraMonths, fraYears);
        // 2) Claim age from user input fields (years + months)
        const claimYears = Number(data["Enter Years"] || 0);
        const claimMonths = Number(data["Enter Months"] || 0);

        // 3) Spousal benefit at FRA (source from your socialFieldsData or input)
        const FRA_spousalBenefit = Number(
          (socialFieldsData &&
            (socialFieldsData["Spouse Monthly Benefit at FRA ($)"] ||
              socialFieldsData["Your Monthly Benefit at FRA ($)"])) ||
            (socialData && socialData["Spouse Monthly Benefit at FRA ($)"]) ||
            0
        );

        const COLA = 0.02;
        const discountRate = 0.03;

        // 4) Single row (Your Entry)
        const lastResultData = calculateSpousalRow(
          claimYears,
          claimMonths,
          fraYears,
          fraMonths,
          FRA_spousalBenefit,
          COLA,
          discountRate
        );
        const spouseFRADisplay = `${fraYears || 0} Years and ${
          fraMonths || 0
        } Months`;
        setUserEntryResults({
          ...lastResultData,
          spouseFRADisplay: spouseFRADisplay,
        });

        // 5) Full table (62 up to FRA+3 by default; adjust min/maxAge as desired)
        const tableDataAll = generateSpousalTable(
          fraYears,
          fraMonths,
          FRA_spousalBenefit,
          COLA,
          discountRate,
          62,
          fraYears
        );

        setTableData(tableDataAll);
      } else {
        let data = {};
        if (
          !data["Spouse Date of Birth"] &&
          socialData &&
          socialData["Spouse Birthdate"]
        ) {
          data["Spouse Date of Birth"] = socialData["Spouse Birthdate"];
        }
        console.log("dataaa2222", data, socialData);
        setFormData(data);
        let birthYear;
        if (data["Spouse Date of Birth"] || socialData["Spouse Birthdate"]) {
          const d = new Date(
            data["Spouse Date of Birth"] || socialData["Spouse Birthdate"]
          );
          if (!isNaN(d)) birthYear = d.getFullYear();
        }
        // fallback: if no DOB use a default or a value you already have
        const { fraYears, fraMonths } = getFRAFromBirthYear(birthYear || 1956);
        // 2) Claim age from user input fields (years + months)
        const claimYears = Number(data["Enter Years"] || 0);
        const claimMonths = Number(data["Enter Months"] || 0);

        // 3) Spousal benefit at FRA (source from your socialFieldsData or input)
        const FRA_spousalBenefit = Number(
          (socialFieldsData &&
            (socialFieldsData["Spouse Monthly Benefit at FRA ($)"] ||
              socialFieldsData["Your Monthly Benefit at FRA ($)"])) ||
            (socialData && socialData["Spouse Monthly Benefit at FRA ($)"]) ||
            0
        );

        const COLA = 0.02;
        const discountRate = 0.03;

        // 4) Single row (Your Entry)
        const lastResultData = calculateSpousalRow(
          claimYears,
          claimMonths,
          fraYears,
          fraMonths,
          FRA_spousalBenefit,
          COLA,
          discountRate
        );
        const spouseFRADisplay = `${fraYears || 0} Years and ${
          fraMonths || 0
        } Months`;
        setUserEntryResults({
          ...lastResultData,
          spouseFRADisplay: spouseFRADisplay,
        });

        // 5) Full table (62 up to FRA+3 by default; adjust min/maxAge as desired)
        const tableDataAll = generateSpousalTable(
          fraYears,
          fraMonths,
          FRA_spousalBenefit,
          COLA,
          discountRate,
          62,
          fraYears
        );

        setTableData(tableDataAll);
      }
    } catch (error) {
      console.error("Error fetching attributes", error);
    } finally {
      setLoading(false);
    }
  };
  const getFields = async (Name) => {
    setLoadingAttributes(true);
    try {
      const res = await MODULE_API.assetFiledDetails(Name);
      if (res && res.attributes) {
        const allAttributes = [...res.attributes];
        const sortedAttributes =
          allAttributes &&
          allAttributes.sort(
            (a, b) => a.groupPriorityValue - b.groupPriorityValue
          );
        setAttributes(sortedAttributes);
      }
    } finally {
      setLoadingAttributes(false);
    }
  };
  const createAttributes = async () => {
    try {
      setLoading(true);
      const result = await MODULE_API.addAsset(module, {
        clientModules: [formData],
      });
      if (formData && formData["Spouse Date of Birth"] && socialFieldsData) {
        await MODULE_API.updateClientModule(socialFieldsData.id, {
          "Spouse Birthdate": formData["Spouse Date of Birth"],
        });
      } else {
        await MODULE_API.addAsset(moduleDataToFetch, {
          clientModules: [
            {
              "Spouse Birthdate": formData["Spouse Date of Birth"],
            },
          ],
        });
      }
      await fetchModuleData(module);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };
  const updateRecord = async () => {
    try {
      setLoading(true);
      await MODULE_API.updateClientModule(formData.id, {
        ...formData,
      });
      if (formData && formData["Spouse Date of Birth"] && socialFieldsData) {
        await MODULE_API.updateClientModule(socialFieldsData.id, {
          "Spouse Birthdate": formData["Spouse Date of Birth"],
        });
      } else {
        await MODULE_API.addAsset(moduleDataToFetch, {
          clientModules: [
            {
              "Spouse Birthdate": formData["Spouse Date of Birth"],
            },
          ],
        });
      }
      await fetchModuleData(module);
      setLoading(false);
    } catch (error) {
      console.error("Error updating record", error);
    } finally {
      setLoading(false);
    }
  };
  const fetchAll = async () => {
    const socialData = await fetchData();
    await fetchModuleData(module, socialData);
  };
  useEffect(() => {
    getFields(module);
    fetchAll();
  }, []);

  const handleCalculate = () => {
    if (!formData) return;
    // 1) Get FRA from spouse DOB if provided (formData.spouseYearOfBirth could be Date string or Date)
    if (formData && formData.id) {
      updateRecord();
    } else {
      createAttributes();
    }
    let birthYear;
    if (
      formData["Spouse Date of Birth"] ||
      socialFieldsData && socialFieldsData["Spouse Birthdate"]
    ) {
      const d = new Date(
        formData["Spouse Date of Birth"] || socialFieldsData["Spouse Birthdate"]
      );
      if (!isNaN(d)) birthYear = d.getFullYear();
    }
    // fallback: if no DOB use a default or a value you already have
    const { fraYears, fraMonths } = getFRAFromBirthYear(birthYear || 1956);
    console.log("fraMonths", fraMonths, fraYears);
    // 2) Claim age from user input fields (years + months)
    const claimYears = Number(formData["Enter Years"] || 0);
    const claimMonths = Number(formData["Enter Months"] || 0);

    // 3) Spousal benefit at FRA (source from your socialFieldsData or input)
    const FRA_spousalBenefit = Number(
      (socialFieldsData &&
        (socialFieldsData["Spouse Monthly Benefit at FRA ($)"] ||
          socialFieldsData["Your Monthly Benefit at FRA ($)"])) ||
        0
    );

    const COLA = 0.02;
    const discountRate = 0.03;

    // 4) Single row (Your Entry)
    const lastResultData = calculateSpousalRow(
      claimYears,
      claimMonths,
      fraYears,
      fraMonths,
      FRA_spousalBenefit,
      COLA,
      discountRate
    );
    const spouseFRADisplay = `${fraYears || 0} Years and ${
      fraMonths || 0
    } Months`;
    setUserEntryResults({
      ...lastResultData,
      spouseFRADisplay: spouseFRADisplay,
    });

    // 5) Full table (62 up to FRA+3 by default; adjust min/maxAge as desired)
    const tableDataAll = generateSpousalTable(
      fraYears,
      fraMonths,
      FRA_spousalBenefit,
      COLA,
      discountRate,
      62,
      fraYears
    );

    setTableData(tableDataAll);
    // console.log("tabledararara", tableDataAll, lastResultData);
  };

  return (
    <div className="social-security-main">
      <div
        className="social-security-back-container"
        onClick={() => {
          history.push("/planner/social-security");
        }}
      >
        <div className="social-security-back-icon-container">
          <img width={16} height={16} src={backIcon} alt={"back Icon"}></img>
        </div>
        {/* {moduleData.name} */}
        <div className="social-security-back-text">Back to Social Security</div>
      </div>
      <div className="social-security-main-heading-container">
        <div className="social-security-icon-container">
          <img
            width={32}
            height={32}
            src={icon1}
            alt={"Retirement Calculator"}
          ></img>
        </div>
        {/* {moduleData.name} */}
        <div className="social-security-main-heading">
          Spousal Social Security Early vs Starting at Full Retirement Age
          <ToolTipCreator name={"retirement_earnings_tooltip"} />
        </div>
      </div>
      <div className="social-security-calculator-content-main">
        <div className="social-security-calculator-content-form-container">
          <div className="social-security-sub-title">
            Spouse's Full Retirement Age is{" "}
            {userEntryResults && userEntryResults.spouseFRADisplay
              ? userEntryResults.spouseFRADisplay
              : "0 Years and 0 Months"}
          </div>
          {loadingAttributes ? (
            <SocialSecurityFormSkeleton rows={1} />
          ) : (
            <SocialSecurityFormFields
              formFields={attributes && attributes}
              formData={formData && formData}
              onChange={handleChange}
            />
          )}
          <button
            className="social-security-calculator-submit-button"
            onClick={(e) => {
              e.preventDefault();
              handleCalculate();
            }}
            disabled={loading || loadingAttributes || !formData}
          >
            Apply
          </button>
        </div>
        <div className="social-security-calculator-results">
          <h3>Results</h3>
          <div className="social-security-result-tag-container">
            {resultArray &&
              resultArray.map((item, index) => (
                <div
                  key={index}
                  className="social-security-main-heading-container"
                >
                  <div className="social-security-result-icon-container">
                    <img
                      width={32}
                      height={32}
                      src={item.icon}
                      alt={item.name}
                    ></img>
                  </div>
                  <div className="social-security-results-main">
                    <div className="social-result-heading">{item.name} </div>
                    <div className="social-result-value">
                      {loading ? <NumberCardSkeleton /> : item.value}{" "}
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </div>
      <div className="retirement-calculator-main">
        <div className="social-security-main-heading-container">
          {/* {moduleData.name} */}
          <div className="social-security-main-heading">
            Breakdown of the results
          </div>
        </div>
        <div
          className="social-security-calculator-content-main"
          style={{ position: "relative" }}
        >
          <CombinedSocialSecurityTable
            tableData={tableData && tableData}
            cols={columns}
          />
          <NewLoader isLoading={loading} />
        </div>
        <div
          className="summary-section-container"
          style={{
            alignItems: "baseline",
            flexWrap: "wrap",
            borderRadius: "8px",
            gap: "8px",
          }}
        >
          <div style={{ minWidth: "fit-content", width: "17%" }}>
            <div
              className="summary-section"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                border: "none",
              }}
            >
              <div className="total-summary-section">
                <h2 className="total-summary">Results</h2>
              </div>
              <div className="average-budget-summary-section">
                <h2 className="average-budget-summary">Your Entry</h2>
              </div>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              gap: "8px",
              flexWrap: "wrap",
              width: "82%",
            }}
          >
            {allResults &&
              allResults.map((item, index) => (
                <div
                  key={index}
                  className="amount-spend-section"
                  style={{
                    borderLeft: "1px solid #d1d5db",
                    padding: "8px",
                    width: "18%",
                    textAlign: "center",
                  }}
                >
                  <div className="amount-spend-title-section">
                    <h2 className="spend-amount-title">{item.name}</h2>
                  </div>
                  <div className="spend-amount-amount-section">
                    <h2 className="spend-amount-amount">
                      {loading ? <NumberCardSkeleton /> : item.value}
                    </h2>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </div>
    </div>
  );
};
